import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col bg-white z-50" }
const _hoisted_2 = { class: "relative h-48" }
const _hoisted_3 = { class: "grid justify-items-end absolute bottom-1 right-1" }
const _hoisted_4 = {
  class: "flex-1 pt-4 px-4 pb-2",
  "data-cy": "immobilie-stammdaten"
}

import AButton from '@/components/Base/AButton.vue';
import AImage from '@/components/Base/AImage.vue';
import Immobilie from '@/models/immobilie.model';
import { getPhotoUrl } from '@/utilities/get-media-url';
import { PropType } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PropertyInfo',
  props: {
    property: {
        type: Object as PropType<Immobilie>,
        required: true
    },
    canAccessPhotos: {
        type: Boolean,
        required: true
    }
},
  emits: ["addPreview", "addMorePhotos", "openGallery"],
  setup(__props) {






return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(AImage, {
          "image-class": "object-cover h-full w-full",
          "data-cy": "immobilie-vorschaubild",
          src: _unref(getPhotoUrl)(__props.property?.vorschaubild, { thumbnail: true})
        }, null, 8, ["src"]),
        _createElementVNode("div", _hoisted_3, [
          (__props.canAccessPhotos && __props.property.vorschaubild)
            ? (_openBlock(), _createBlock(AButton, {
                key: 0,
                type: 'submit',
                "btn-tertiary": true,
                "data-cy": "immobilie-vorschaubild",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('addPreview')))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("immobilie.buttons.vorschaubildAendern")), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (__props.canAccessPhotos && !__props.property.vorschaubild)
            ? (_openBlock(), _createBlock(AButton, {
                key: 1,
                "btn-tertiary": true,
                "data-cy": "immobilie-vorschaubild-hinzufuegen",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('addPreview')))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("immobilie.buttons.vorschaubildHinzufuegen")), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (__props.canAccessPhotos)
            ? (_openBlock(), _createBlock(AButton, {
                key: 2,
                "btn-tertiary": true,
                "data-cy": "immobilie-weitere-bilder-hinzufuegen",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('addMorePhotos')))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("immobilie.buttons.weitereFotoshinzufuegen")), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (__props.property?.bilder?.length > 0 || __props.property.vorschaubild)
            ? (_openBlock(), _createBlock(AButton, {
                key: 3,
                "btn-tertiary": true,
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('openGallery')))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("immobilie.buttons.weitereAnzeigen")), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", null, [
        _renderSlot(_ctx.$slots, "fields")
      ])
    ])
  ]))
}
}

})